import instance from "../utils/network";
import defaultPresetData from "../utils/default_preset.json";

export interface StructurePresetResponseDto {
  id: number;
  cafeId: number;
  presetName: string;
  preset: string;
}

export interface StructurePresetRequestDto {
  cafeId: number;
  presetName?: string;
  preset: string;
}

export interface StatusPresetRequestDto {
  pubId: number;
  presetName?: string;
  preset: string;
}

export interface StructurePresetPageResponseDto {
  total: number;
  preset: StructurePresetResponseDto[];
}

export interface StatusPresetResponseDto {
  id: number;
  pubId: number;
  presetName: string;
  preset: string;
}

export interface StatusPresetPageResponseDto {
  total: number;
  preset: StatusPresetResponseDto[];
}

const DEFAULT_PRESET_ID_OFFSET = -1000;

export function isDefaultPreset(id: number) {
  return id <= DEFAULT_PRESET_ID_OFFSET;
}

function getDefaultPresets(cafeId: number): StructurePresetResponseDto[] {
  return defaultPresetData.preset.map((preset, index) => {
    const parsedPreset = JSON.parse(preset.preset);

    return {
      id: DEFAULT_PRESET_ID_OFFSET - index,
      cafeId,
      presetName: preset.presetName,
      preset: JSON.stringify({ ...parsedPreset, cafeId }),
    };
  });
}

export async function getStructurePresetsByCafeId(
  cafeId: number,
  page: number,
  limit: number,
): Promise<StructurePresetPageResponseDto> {
  const res: StructurePresetPageResponseDto = await instance.get(
    `/seller/pub-tournament-preset/preset/${cafeId}`,
    { params: { page, limit } },
  );

  const serverPresetNames = new Set(res.preset.map((p) => p.presetName));
  const defaultPresets = getDefaultPresets(cafeId).filter(
    (p) => !serverPresetNames.has(p.presetName),
  );

  return {
    total: res.total + defaultPresets.length,
    preset: [...defaultPresets, ...res.preset],
  };
}

export function registerTournamentPreset(
  request: StructurePresetRequestDto,
): Promise<{ code: number; message: any }> {
  return instance.post("/seller/pub-tournament-preset/preset", request);
}

export function updateTournamentPreset(
  id: number,
  request: StructurePresetRequestDto,
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/pub-tournament-preset/preset/${id}`, request);
}

export function removeTournamentPreset(
  id: number,
  pubId: number,
): Promise<{ code: number; message: any }> {
  return instance.delete(
    `/seller/pub-tournament-preset/preset/${id}?pubId=${pubId}`,
  );
}

export function getTournamentStatusPreset(
  pubId: number,
): Promise<StatusPresetPageResponseDto> {
  return instance.get(`/seller/pub-tournament-preset/status/${pubId}`);
}

export function registerTournamentStatusPreset(
  request: StatusPresetRequestDto,
): Promise<{ code: number; message: any }> {
  return instance.post("/seller/pub-tournament-preset/status", request);
}

export function updateTournamentStatusPreset(
  id: number,
  request: StatusPresetRequestDto,
): Promise<{ code: number; message: any }> {
  return instance.put(`/seller/pub-tournament-preset/status/${id}`, request);
}

export function removeTournamentStatusPreset(
  id: number,
): Promise<{ code: number; message: any }> {
  return instance.delete(`/seller/pub-tournament-preset/status/${id}`);
}
